import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface VideoProps {
  videoSources: { src: string; type: string }[];
  posterSrc: string;
  posterSrcSet?: string;
  altText: string;
}

const Video: React.FC<VideoProps> = ({
  videoSources,
  posterSrc,
  posterSrcSet,
  altText,
}) => {
  const { t, i18n } = useTranslation();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPosterShown, setIsPosterShown] = useState(true);

  useEffect(() => {
    if (videoRef.current) {
      setIsPosterShown(true);
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [i18n.language]);

  return (
    <div>
      <div className='relative h-auto w-full'>
        {isPosterShown && (
          <img
            src={posterSrc}
            srcSet={posterSrcSet}
            alt={altText}
            className='absolute inset-0 z-10 h-full w-full cursor-pointer rounded-lg object-cover'
            onClick={() => {
              setIsPosterShown(false);
              videoRef?.current?.play();
            }}
          />
        )}
        <video
          ref={videoRef}
          controls
          className={`w-full transition-opacity duration-300 ${
            isPosterShown ? 'opacity-0' : 'opacity-100'
          }`}
          onEnded={() => {
            if (videoRef.current) {
              videoRef.current.pause();
              videoRef.current.currentTime = 0;
              setIsPosterShown(true);
            }
          }}
        >
          {videoSources.map((source, index) => (
            <source key={index} src={source.src} type={source.type} />
          ))}
          <p>{t('Your browser does not support the video tag')}</p>
        </video>
      </div>
    </div>
  );
};

export default Video;
